export default __webpack_public_path__ + "static/IBMPlexSans-Bold-Greek-912048ed585fe9a946c1e360d086d4cd.woff";